/**
 * Strips the protocol from a web address
 */
const formatWebAddress = (value = '') => value.replace(/http[s]*:\/\//, '');

export default formatWebAddress;
